// @flow
import { call, put, takeEvery, select } from 'redux-saga/effects'
// $FlowFixMe
import { push } from 'react-router-redux'
import { PROCESS_PAYMENT, PROCESS_PAYMENT_SUCCESS, PROCESS_PAYMENT_FAILED, STRIPE_ERROR } from '.'
import type { Booking as BookingProps } from 'src/types'
/*
 * Stripe sagas
 */

const chargeStripe = (
  token: Object,
  booking: BookingProps,
  useStripe: boolean,
  paymentIntent: Object
) => {
  const url = process.env.REACT_APP_CHARGE_GATEWAY || ''
  const fee = booking.adminFee ? parseInt(booking.adminFee, 10) : 0
  const deposit = booking.bookingDeposit ? parseInt(booking.bookingDeposit, 10) : 0
  const requestBody = {
    country: 'UK',
    currency: 'gbp',
    source: token.id,
    amount: 100 * (deposit + fee),
    metadata: {
      first_name: booking.member.firstName,
      last_name: booking.member.lastName
    },
    booking,
    paymentIntent,
    useStripe
  }
  return fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  })
    .then(response => response.json())
    .then(json => json)
    .catch(error => {
      return { error }
    })
}

const getPaymentIntent = state => state.stripe.paymentIntent

function* processStripePayment(action) {
  const {
    payload: { token, booking, useStripe = true }
  } = action

  if (!booking) {
    return
  }
  if (!useStripe) {
    const response = yield call(chargeStripe, token, booking, useStripe)
    if (response.error) {
      yield put(push('/oops'))
      yield put({ type: PROCESS_PAYMENT_FAILED, reason: '' })
    } else {
      yield put(push('/thanks'))
      yield put({ type: PROCESS_PAYMENT_SUCCESS })
    }
  } else {
    const paymentIntent = yield select(getPaymentIntent)
    const response = yield call(chargeStripe, token, booking, useStripe, paymentIntent)
    if (response.error) {
      yield put(push('/oops'))
      yield put({ type: PROCESS_PAYMENT_FAILED, reason: response.message })
    } else {
      yield put(push('/thanks'))
      yield put({ type: PROCESS_PAYMENT_SUCCESS })
    }
  }
}

// $FlowFixMe
export function* onPaymentError({ reason }) {
  yield put(push('/oops'))
  yield put({ type: PROCESS_PAYMENT_FAILED, reason })
}

// $FlowFixMe
export function* watchStripe() {
  // $FlowFixMe
  yield takeEvery(PROCESS_PAYMENT, processStripePayment)
  yield takeEvery(STRIPE_ERROR, onPaymentError)
}



// WEBPACK FOOTER //
// ./src/ducks/stripe/sagas.js